import { Col, Slider } from 'antd';
import React, { useState } from 'react';
import RealTimeImageViewer from './RealTimeImageViewer';
import RealTimeTitleBlock from './RealTimeTitleBlock';

export interface RealTimeImageProps {
}

export default function RealTimeImage(props: RealTimeImageProps) {

    const [scroll, setScroll] = useState(0);
    return <RealTimeTitleBlock title={"运行结果图"}>
        <Col span={11}>
            <RealTimeImageViewer scroll={scroll} setScroll={setScroll} position='left'/>
        </Col>
        <Col span={11}>
            <RealTimeImageViewer scroll={scroll} setScroll={setScroll} position='right'/>
        </Col>
        <Col span={2}>
            <Slider max={100} value={scroll} vertical reverse onChange={(value: number) => { setScroll(value); }} />
        </Col>
    </RealTimeTitleBlock>
}


